module.exports = __webpack_public_path__ + "img/no-note.face68b8.svg";